import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import {
  Icon,
  List,
  ListItem,
  Skeleton,
  StatusController,
  Typography,
} from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../knock-design-system';

export const SKELETON_LABEL = 'loading properties';
export const NO_PROPERTIES_TEXT = 'No properties available.';

const useCss = makeCss({
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '256px',
  },
  cardContent: {
    padding: 0,
    height: '100%',
    overflow: 'auto',
  },
  messageText: {
    margin: '14px',
  },
});

const PropertyList = ({
  errorMessage,
  isLoading,
  properties,
  selectedPropertyId,
  setSelectedPropertyId,
}) => {
  const css = useCss();

  const handlePropertyOnClick = (id) => () => {
    setSelectedPropertyId(id);
  };

  return (
    <Card css={css.card} variant="outlined">
      <CardHeader
        avatar={<Icon name="building-modern-outlined" />}
        title="Properties"
      />

      <Divider />

      <CardContent css={css.cardContent}>
        <StatusController
          empty={properties.length === 0}
          emptyFallback={
            <Typography align="center" css={css.messageText}>
              {NO_PROPERTIES_TEXT}
            </Typography>
          }
          error={Boolean(errorMessage)}
          errorFallback={
            <Typography align="center" css={css.messageText}>
              {errorMessage}
            </Typography>
          }
          loading={isLoading}
          loadingFallback={
            <Skeleton aria-label={SKELETON_LABEL} height={48} variant="rect" />
          }
        >
          <List disablePadding>
            {properties.map((property) => {
              const { id, name } = property;
              const isSelected = selectedPropertyId === id;
              return (
                <ListItem
                  aria-selected={isSelected}
                  button
                  key={property.id}
                  onClick={handlePropertyOnClick(id)}
                  primary={name}
                  selected={isSelected}
                />
              );
            })}
          </List>
        </StatusController>
      </CardContent>
    </Card>
  );
};

PropertyList.propTypes = {
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  properties: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  ),
  selectedPropertyId: PropTypes.number,
  setSelectedPropertyId: PropTypes.func,
};

export default PropertyList;
